$(document).ready(() => {
  let buildModal = document.getElementById('dialog')
  let submitBuiltId = null

  document.addEventListener('DOMContentLoaded', function () {
    window.onclick = function (event) {
      if (event.target == buildModal) {
        buildModal.style.display = 'none'
        if (submitBuiltId !== null) {
          window.location.href = '/pages/build?id=' + submitBuiltId
        }
      }
    }
  })

  $('.btn_confirm').on('click', function () {
    buildModal.style.display = 'none'
    if (submitBuiltId !== null) {
      window.location.href = '/pages/build?id=' + submitBuiltId
    }
  })

  class FitmentString {
    constructor(
      year,
      make,
      model,
      submodel,
      drive_type,
      fuel_type,
      doors,
      type
    ) {
      this.year = year
      this.make = make
      this.model = model
      this.submodel = submodel
      this.drive_type = drive_type
      this.fuel_type = fuel_type
      this.doors = doors
      this.type = type
    }
  }

  function stringToObject(fitmentStrings) {
    let newStrArr
    let stringsToObjects = []
    newStrArr = fitmentStrings.split(';')
    newStrArr.forEach((str) => {
      let tempArr
      tempArr = str.split('|')
      let tempFitmentObject = new FitmentString()
      tempFitmentObject.year = tempArr[0]
      tempFitmentObject.make = tempArr[1]
      tempFitmentObject.model = tempArr[2]
      tempFitmentObject.submodel = tempArr[3]
      tempFitmentObject.drive_type = tempArr[4]
      tempFitmentObject.fuel_type = tempArr[5]
      tempFitmentObject.doors = tempArr[6]
      tempFitmentObject.type = tempArr[7]

      stringsToObjects.push(tempFitmentObject)
    })

    return stringsToObjects
  }

  function checkFitment(metafieldsArr, vehicle) {
    let isFitment = false
    if (metafieldsArr.length > 0 && !isEmpty(vehicle)) {
      metafieldsArr.forEach((item) => {
        if (
          item.year === vehicle.year &&
          (!item.make ||
            !vehicle.make ||
            item.make.toLowerCase() === 'x' ||
            item.make.toLowerCase() === vehicle.make.toLowerCase()) &&
          (!item.model ||
            !vehicle.model ||
            item.model.toLowerCase() === 'x' ||
            item.model.toLowerCase() === vehicle.model.toLowerCase()) &&
          (!item.submodel ||
            !vehicle.submodel ||
            item.submodel.toLowerCase() === 'x' ||
            item.submodel.toLowerCase() === vehicle.submodel.toLowerCase()) &&
          (!item.drive_type ||
            !vehicle.drive_type ||
            item.drive_type.toLowerCase() === 'x' ||
            item.drive_type.toLowerCase() ===
              vehicle.drive_type.toLowerCase()) &&
          (!item.fuel_type ||
            !vehicle.fuel_type ||
            item.fuel_type.toLowerCase() === 'x' ||
            item.fuel_type.toLowerCase() === vehicle.fuel_type.toLowerCase()) &&
          (!item.doors ||
            !vehicle.doors ||
            item.doors.toLowerCase() === 'x' ||
            item.doors.toLowerCase() === vehicle.doors.toLowerCase()) &&
          (!item.type ||
            !vehicle.type ||
            item.type.toLowerCase() === 'x' ||
            item.type.toLowerCase() === vehicle.type.toLowerCase())
        ) {
          isFitment = true
        }
      })
    }

    return isFitment
  }

  const data = {}
  const form_data = new FormData()
  const baseApi = 'https://fitmentapi.azurewebsites.net/api/ymm?store_id=bds'
  const currentVehicle = {}
  let submittedFiles = []

  const buildData = JSON.parse(localStorage.getItem('build'))
  if (buildData) {
    delete buildData['imagedrop']
    delete buildData['product-search-input']
    let param = ''
    $.each(buildData, function (k, v) {
      const txtFieldsArray = ['username', 'city_state', 'instagram']
      const selectFieldsArray = [
        'preferredUser',
        'tire_size',
        'wheel_size',
        'wheel_offset',
        'triming',
      ]
      if (txtFieldsArray.indexOf(k) > -1) {
        $('input[name=' + k + ']').val(v)
        $('input[name=' + k + ']')
          .removeClass('invalid')
          .addClass('valid')
      } else if (k === 'comments') {
        $('#additional_accessories').val(v)
      } else if (k === 'products') {
        let html = ''
        v.map((item) => {
          html +=
            '<li data-path="' +
            item.path +
            '" data-pid="' +
            item.pId +
            '" data-handle="' +
            item.handle +
            '" data-price="' +
            item.price +
            '">' +
            item.name +
            '<button class="remove-tag tag-action is-active" type="button"><i class="fas fa-times"></i></button></li>'
        })
        $('#no-products-msg').hide()
        $('#selected_active-products').append(html)
      } else {
        $('input[name=' + k + '_select]').val(v)
        $('input[name=' + k + '_select]')
          .removeClass('invalid')
          .addClass('valid')
        if (selectFieldsArray.indexOf(k) > -1) {
          $.each($('#' + k + '_select option'), function () {
            if ($(this).text() === v) {
              $(this).attr('selected', 'selected')
            }
          })
        } else {
          if (k === 'year') {
            getData('').then((data) => {
              if (Object.keys(data.result).length > 0) {
                makeSelect(
                  Object.keys(data.result)[0],
                  data.result.year.reverse(),
                  parseInt(v)
                )
              }
            })
            param = k + '=' + v
          } else {
            getData(param).then((data) => {
              if (
                Object.keys(data.result).length > 0 &&
                Object.keys(data.result)[0] != 'sku'
              ) {
                makeSelect(
                  Object.keys(data.result)[0],
                  data.result[Object.keys(data.result)[0]],
                  v
                )
              }
            })
            param += '&' + k + '=' + v
          }
        }
      }
      data[k] = v
    })
    displayTabs(0)
  } else {
    getData('').then((data) => {
      if (Object.keys(data.result).length > 0) {
        makeSelect(Object.keys(data.result)[0], data.result.year.reverse())
      }
    })

    displayTabs(0)
  }

  function removeDuplicates(arr) {
    const uniqueLowercaseValues = []
    const filteredArray = []

    arr.forEach((item) => {
      const lowercaseItem = item.toString().toUpperCase()

      if (!uniqueLowercaseValues.includes(lowercaseItem)) {
        uniqueLowercaseValues.push(lowercaseItem)
        filteredArray.push(item)
      }
    })

    return filteredArray
  }

  function makeSelect(id, optionArray, v) {
    const filteredOptions = removeDuplicates(optionArray)
    if (filteredOptions.length > 0) {
      if (id == 'year' || id == 'make' || id == 'model') {
        let html = ''
        filteredOptions.map((option) => {
          html +=
            '<option class="option_select" ' +
            (option === v ? 'selected' : '') +
            '>' +
            option +
            '</option>'
        })
        $('#' + id + '_select').append(html)
        $('#' + id + '_select').attr('disabled', false)
      } else {
        let html =
          '<div class="form__row gallery_select_form" id="' +
          id +
          '__form">' +
          '<label class="form__label" for="model_select"><span>' +
          (id == 'drive_type'
            ? 'Drive Type'
            : id == 'fuel_type'
            ? 'Fuel Type'
            : id.charAt(0).toUpperCase() + id.slice(1)) +
          '</span></label>' +
          '<div class="control" style="padding: 0"><input type="hidden" name="' +
          id +
          '_select" class="invalid"/>' +
          '<select id="' +
          id +
          '_select" class="form-control gallery_fitment_select select__select">' +
          '<option selected hidden>' +
          (id == 'drive_type'
            ? 'Drive Type'
            : id == 'fuel_type'
            ? 'Fuel Type'
            : id.charAt(0).toUpperCase() + id.slice(1)) +
          '</option>'
        filteredOptions.map((option) => {
          html +=
            '<option  class="option_select" ' +
            (option === v ? 'selected' : '') +
            '>' +
            option +
            '</option>'
        })
        $('.select_main_form').append(html + '</select></div></div>')
      }
    }
  }

  function makeParam(type) {
    let param = ''
    let isAdding = true
    let keyArray = []
    $.each(currentVehicle, function (k, v) {
      if (isAdding) {
        param += k + '=' + v + '&'
        keyArray.push(k)
      } else {
        delete currentVehicle[k]
      }
      if (k == type) {
        isAdding = false
      }
    })
    $.each($('.gallery_select_form'), function () {
      if (!keyArray.includes($(this).attr('id').replace('__form', ''))) {
        let id = $(this).attr('id').replace('__form', '')
        if (id == 'make' || id == 'model') {
          $('#' + id + '_select option[class="option_select"]').remove()
          $('#' + id + '_select').attr('disabled', true)
        } else {
          $(this).remove()
        }
      }
    })
    return param.slice(0, -1)
  }

  function isSelectedProducts(product_title) {
    let result = false
    $('#selected_active-products li').each(function () {
      if ($(this).text().trim() === product_title.trim()) {
        result = true
      }
    })

    return result
  }

  $(document).on('change', '.gallery_fitment_select', function () {
    if (
      $(this).attr('id') === 'tire_size_select1' ||
      $(this).attr('id') === 'tire_size_select2'
    ) {
      if ($(this).val() === 'Other') {
        $('#' + $(this).attr('id') + '_input').removeClass('hidden')
      } else {
        $('#' + $(this).attr('id') + '_input').addClass('hidden')
      }
    } else if (
      $(this).attr('id') === 'model_select' ||
      $(this).attr('id') === 'submodel_select' ||
      $(this).attr('id') === 'drive_type_select' ||
      $(this).attr('id') === 'fuel_type_select' ||
      $(this).attr('id') === 'type_select'
    ) {
      getAllProducts().then((html) => {
        let customHtml = ''
        const uniqueProductDetails = new Set()
        $.each($(html).find('.product_details_item'), function () {
          if (
            checkFitment(
              stringToObject(
                $(this).find('input[type="hidden"]').val().slice(0, -1)
              ),
              data
            )
          ) {
            const productDetails = $(this).find('.card-title span').text()
            if (!uniqueProductDetails.has(productDetails)) {
              customHtml +=
                '<div class="search_product-tile" role="option">' +
                '<div class="search_product-tile__inner">' +
                ($(this).find('img').data('srcset')
                  ? '<img src="' +
                    $(this).find('img').data('srcset') +
                    '" width="150" height="100">'
                  : `<div style="width: 150px; height: 100px;">{{ 'image' | placeholder_svg_tag: 'placeholder-svg' }}</div>`) +
                '<div class="search_product-tile__details">' +
                '<div class="product-tile__name">' +
                $(this).find('.card-title span').text() +
                '</div>' +
                '<div class="product-tile__details-upper" data-pid="' +
                $(this).find('.product-item').data('product-id') +
                '"></div>' +
                '<div class="product-tile_handle">' +
                $(this).find('.product-item').data('json-product').handle +
                '</div>' +
                '<div class="product-tile_price">' +
                $(this).find('.price-item--sale').text() +
                '</div>' +
                '<div class="product-tile__actions">' +
                '<button type="button" class="button button--txt tag-action">' +
                (isSelectedProducts($(this).find('.card-title span').text())
                  ? '<i class="fas fa-times"></i> Remove'
                  : '<i class="fas fa-plus"></i> Select') +
                '</button>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>'
              uniqueProductDetails.add(productDetails)
            }
          }
        })
        $('#product-search-results').html(customHtml)
      })
    }
    const validSelectArr = [
      'year',
      'make',
      'model',
      'submodel',
      'drive_type',
      'fuel_type',
      'doors',
      'body_type',
      'position',
      'lift_height',
      'tire_size',
      'wheel_size',
      'wheel_offset',
    ]
    if (
      validSelectArr.indexOf($(this).attr('id').replace('_select', '')) > -1
    ) {
      currentVehicle[$(this).attr('id').replace('_select', '')] = $(this).val()
      getData(makeParam($(this).attr('id').replace('_select', ''))).then(
        (data) => {
          if (
            Object.keys(data.result).length > 0 &&
            Object.keys(data.result)[0] != 'sku'
          ) {
            makeSelect(
              Object.keys(data.result)[0],
              data.result[Object.keys(data.result)[0]]
            )
          }
        }
      )
      $('input[name="' + $(this).attr('id') + '"]').val($(this).val())
      $('input[name="' + $(this).attr('id') + '"]')
        .removeClass('invalid')
        .addClass('valid')
      $('#' + $(this).attr('id') + '-error').hide()
      data[$(this).attr('id').replace('_select', '')] = $(this).val()
    } else {
      data[$(this).attr('id').replace('_select', '')] = $(this).val()
    }

    $('#selected_active-products li button').each(function () {
      const title = $(this).parent().text()
      const object = $(this).parent()
      $('.search_product-tile__inner .product-tile__name').each(function () {
        if ($(this).text().trim() === title.trim()) {
          $(this)
            .parent()
            .find('.product-tile__actions button')
            .html('<i class="fas fa-plus"></i> Select')
          object.remove()
        }
      })

      if ($('#selected_active-products li').length == 0) {
        $('#no-products-msg').show()
      }
    })
  })

  async function getData(param) {
    const res = await fetch(baseApi + '&' + param, { method: 'GET' })
    return res.json()
  }

  function displayTabs(index) {
    $('.progress-bar__step').removeClass('is-active')
    $('.form__tab').hide()
    if (index == 0) {
      $('.form__tab:nth(' + index + ')').show()
      $('.progress-bar__step')[0]?.classList.add('is-active')
      $('#prevBtn').hide()
      $('#nextBtn').show()
      $('#submitBtn').hide()
      $('#loginBtn').hide()
      $('.disclaimer_container').hide()
    } else if (index == 1) {
      $('.form__tab:nth(' + index + ')').show()
      $('.progress-bar__step')[1]?.classList.add('is-active')
      $('#prevBtn').show()
      $('#nextBtn').show()
      $('#submitBtn').hide()
      $('#loginBtn').hide()
      $('.disclaimer_container').hide()
    } else if (index == 2) {
      $('.form__tab:nth(' + index + ')').show()
      $('.progress-bar__step')[2]?.classList.add('is-active')
      $('#prevBtn').show()
      $('#nextBtn').hide()
      if (userId) {
        $('#loginBtn').hide()
        $('#submitBtn').show()
        $('.disclaimer_container').show()
      } else {
        $('#loginBtn').show()
        $('#submitBtn').hide()
        $('.disclaimer_container').hide()
      }
    }

    ScrollToTop()
    localStorage.setItem('gallery', index)
  }

  function ScrollToTop() {
    $('html, body').animate({ scrollTop: $('body').offset().top - 50 }, 'quick')
  }

  $('#nextBtn').on('click', function () {
    const index = localStorage.getItem('gallery')
    if (index && validation()) {
      displayTabs(parseInt(index) + 1)
    }
    let products = []
    $('#selected_active-products li').each(function () {
      products.push({ handle: $(this).data('handle') })
    })
    if (products.length > 0) {
      data['products'] = products
    }
    console.log(data)
  })

  $('#prevBtn').on('click', function () {
    const index = localStorage.getItem('gallery')
    if (index) {
      displayTabs(parseInt(index) - 1)
    }
  })

  $('#submitBtn').on('click', function () {
    if ($('.uploader__preview img').length == 0) {
      $('#imagedrop-error').show()
    } else {
      $('#imagedrop-error').hide()
      progress()
      data['userId'] = userId
      data['email'] = email
      data['votes'] = []
      delete data['imagedrop']
      delete data['product-search-input']
      for (let i = 0; i < submittedFiles.length; i++) {
        const fileInput = submittedFiles[i]
        if (fileInput && fileInput.length > 0) {
          const file = fileInput[0]
          form_data.append('images', file)
        }
      }
      $.ajax({
        url: 'https://bdsgallery-function.azurewebsites.net/api/uploads',
        type: 'POST',
        data: form_data,
        cache: false,
        processData: false,
        contentType: false,
        success: function (res) {
          if (JSON.parse(res).length > 0) {
            data['images'] = JSON.parse(res)
            $.ajax({
              url: 'https://bdsgallery-function.azurewebsites.net/api/builds',
              type: 'POST',
              data: JSON.stringify(data),
              dataType: 'json',
              success: function (res) {
                $.unblockUI()
                $('.progress-bar__step')[2].classList.remove('is-active')
                localStorage.removeItem('build')
                submitBuiltId = res[0]._id
                $('#dialog .header strong').text('BDS Suspension!')
                $('#dialog .header').css('background', '#232323')
                $('#dialog .body p').text('Thank you for your submission!')
                buildModal.style.display = 'block'
              },
              error: function (res) {
                $.unblockUI()
                if (res.status === 200 && res.statusText === 'OK') {
                  $('.progress-bar__step')[2].classList.remove('is-active')
                  submitBuiltId = res[0]._id
                  $('#dialog .header strong').text('BDS Suspension!')
                  $('#dialog .header').css('background', '#232323')
                  $('#dialog .body p').text('Thank you for your submission!')
                  buildModal.style.display = 'block'
                }
              },
            })
          } else {
            $('#dialog .header strong').text('Warnning!')
            $('#dialog .header').css('background', 'red')
            $('#dialog .body p').text(
              'Sorry, the images you uploaded could not be verified or are an incorrect file type. Please try again with other images'
            )
            buildModal.style.display = 'block'
            $.unblockUI()
          }
        },
        error: function (res) {
          $.unblockUI()
        },
      })
    }
  })

  function validation() {
    let result = true
    const form_data = $('.form-gallery-submission').serializeArray()
    const validArr = [
      'username',
      'city_state',
      'year_select',
      'make_select',
      'model_select',
      'lift_height_select',
    ]
    form_data.map((item) => {
      if (validArr.indexOf(item.name) > -1) {
        if ($('input[name="' + item.name + '"]').hasClass('invalid')) {
          result = false
          $('#' + item.name + '-error').show()
        } else {
          $('#' + item.name + '-error').hide()
        }
      }
    })
    if (!result) {
      ScrollToTop()
    }
    return result
  }

  $('.form__tabs input').on('input', function () {
    id = $(this).attr('id')
    const validArr = [
      'username',
      'city_state',
      'instagram',
      'offset',
      'wheel_brand',
      'wheel_model',
      'tire_size_select1_input',
      'tire_size_select2_input',
      'tire_brand',
      'tire_model',
    ]
    if (validArr.indexOf(id) > -1 && $(this).val() !== '') {
      $('input[name="' + id + '"]')
        .removeClass('invalid')
        .addClass('valid')
      data[id] = $(this).val()
      $('#' + id + '-error').hide()
    } else {
      $('input[name="' + id + '"]')
        .removeClass('valid')
        .addClass('invalid')
      delete data[id]
    }
  })

  function getProducts(url) {
    return fetch(url, { method: 'GET' })
      .then((response) => response.text())
      .catch((error) => {
        console.error('Error fetching search results:', error)
      })
  }

  function getCollectionProducts(url) {
    return fetch(url, { method: 'GET' })
      .then((response) => response.text())
      .then((html) => {
        let customHtml = ''
        $.each($(html).find('.collections_products_container'), function () {
          customHtml += $(this).html()
        })

        return customHtml
      })
      .catch((error) => {
        console.error('Error fetching search results:', error)
      })
  }

  const getAllSearchedProducts = async (search_key) => {
    try {
      let html = ''
      const promises = []

      for (let i = 1; i <= 100; i++) {
        promises.push(
          getProducts(`/search?q=${search_key}&view=alternative&page=${i}`)
        )
      }

      const dataResponses = await Promise.all(promises)

      dataResponses.forEach((data) => {
        html += data
      })

      return html
    } catch (error) {
      console.error('Error fetching data:', error)
      throw error
    }
  }

  const getAllProducts = async () => {
    try {
      let html = ''
      const promises = []

      for (let i = 1; i <= 20; i++) {
        promises.push(
          getCollectionProducts(
            `https://bds-suspension.myshopify.com/collections?page=${i}`
          )
        )
      }

      const dataResponses = await Promise.all(promises)

      dataResponses.forEach((data) => {
        html += data
      })

      return html
    } catch (error) {
      console.error('Error fetching data:', error)
      throw error
    }
  }

  $('#product-search-btn').on('click', function () {
    progress()
    if ($('#product-search-input').val() === '') {
      getAllProducts().then((html) => {
        let customHtml = ''
        const uniqueProductDetails = new Set()
        $.each($(html).find('.product_details_item'), function () {
          if (
            checkFitment(
              stringToObject(
                $(this).find('input[type="hidden"]').val().slice(0, -1)
              ),
              data
            )
          ) {
            const productDetails = $(this).find('.card-title span').text()
            if (!uniqueProductDetails.has(productDetails)) {
              customHtml +=
                '<div class="search_product-tile" role="option">' +
                '<div class="search_product-tile__inner">' +
                ($(this).find('img').data('srcset')
                  ? '<img src="' +
                    $(this).find('img').data('srcset') +
                    '" width="150" height="100">'
                  : `<div style="width: 150px; height: 100px;">{{ 'image' | placeholder_svg_tag: 'placeholder-svg' }}</div>`) +
                '<div class="search_product-tile__details">' +
                '<div class="product-tile__name">' +
                $(this).find('.card-title span').text() +
                '</div>' +
                '<div class="product-tile__details-upper" data-pid="' +
                $(this).find('.product-item').data('product-id') +
                '"></div>' +
                '<div class="product-tile_handle">' +
                $(this).find('.product-item').data('json-product').handle +
                '</div>' +
                '<div class="product-tile_price">' +
                $(this).find('.price-item--sale').text() +
                '</div>' +
                '<div class="product-tile__actions">' +
                '<button type="button" class="button button--txt tag-action">' +
                (isSelectedProducts($(this).find('.card-title span').text())
                  ? '<i class="fas fa-times"></i> Remove'
                  : '<i class="fas fa-plus"></i> Select') +
                '</button>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>'
              uniqueProductDetails.add(productDetails)
            }
          }
        })
        $('#product-search-results').html(customHtml)
        $.unblockUI()
      })
    } else {
      getAllSearchedProducts($('#product-search-input').val()).then((html) => {
        let customHtml = ''
        const uniqueProductDetails = new Set()
        $.each($(html).find('.search_product_item'), function () {
          if (
            checkFitment(stringToObject($(this).data('str').slice(0, -1)), data)
          ) {
            const productDetails = $(this).find('.card-title span').text()
            if (!uniqueProductDetails.has(productDetails)) {
              customHtml +=
                '<div class="search_product-tile" role="option">' +
                '<div class="search_product-tile__inner">' +
                ($(this).find('img').data('srcset')
                  ? '<img src="' +
                    $(this).find('img').data('srcset') +
                    '" width="150" height="100">'
                  : `<div style="width: 150px; height: 100px;">{{ 'image' | placeholder_svg_tag: 'placeholder-svg' }}</div>`) +
                '<div class="search_product-tile__details">' +
                '<div class="product-tile__name">' +
                $(this).find('.card-title span').text() +
                '</div>' +
                '<div class="product-tile__details-upper" data-pid="' +
                $(this).find('.product-item').data('product-id') +
                '"></div>' +
                '<div class="product-tile_handle">' +
                $(this).find('.product-item').data('json-product').handle +
                '</div>' +
                '<div class="product-tile_price">' +
                $(this).find('.price-item--sale').text() +
                '</div>' +
                '<div class="product-tile__actions">' +
                '<button type="button" class="button button--txt tag-action">' +
                (isSelectedProducts($(this).find('.card-title span').text())
                  ? '<i class="fas fa-times"></i> Remove'
                  : '<i class="fas fa-plus"></i> Select') +
                '</button>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>'
              uniqueProductDetails.add(productDetails)
            }
          }
        })
        $('#product-search-results').html(customHtml)
        $.unblockUI()
      })
    }
  })

  $('#product-search-input').on('keydown', function (event) {
    if (event.keyCode === 13) {
      progress()
      if ($(this).val() === '') {
        getAllProducts().then((html) => {
          let customHtml = ''
          const uniqueProductDetails = new Set()
          $.each($(html).find('.product_details_item'), function () {
            if (
              checkFitment(
                stringToObject(
                  $(this).find('input[type="hidden"]').val().slice(0, -1)
                ),
                data
              )
            ) {
              const productDetails = $(this).find('.card-title span').text()
              if (!uniqueProductDetails.has(productDetails)) {
                customHtml +=
                  '<div class="search_product-tile" role="option">' +
                  '<div class="search_product-tile__inner">' +
                  ($(this).find('img').data('srcset')
                    ? '<img src="' +
                      $(this).find('img').data('srcset') +
                      '" width="150" height="100">'
                    : `<div style="width: 150px; height: 100px;">{{ 'image' | placeholder_svg_tag: 'placeholder-svg' }}</div>`) +
                  '<div class="search_product-tile__details">' +
                  '<div class="product-tile__name">' +
                  $(this).find('.card-title span').text() +
                  '</div>' +
                  '<div class="product-tile__details-upper" data-pid="' +
                  $(this).find('.product-item').data('product-id') +
                  '"></div>' +
                  '<div class="product-tile_handle">' +
                  $(this).find('.product-item').data('json-product').handle +
                  '</div>' +
                  '<div class="product-tile_price">' +
                  $(this).find('.price-item--sale').text() +
                  '</div>' +
                  '<div class="product-tile__actions">' +
                  '<button type="button" class="button button--txt tag-action">' +
                  (isSelectedProducts($(this).find('.card-title span').text())
                    ? '<i class="fas fa-times"></i> Remove'
                    : '<i class="fas fa-plus"></i> Select') +
                  '</button>' +
                  '</div>' +
                  '</div>' +
                  '</div>' +
                  '</div>'
                uniqueProductDetails.add(productDetails)
              }
            }
          })
          $('#product-search-results').html(customHtml)
          $.unblockUI()
        })
      } else {
        getAllSearchedProducts($('#product-search-input').val()).then(
          (html) => {
            let customHtml = ''
            const uniqueProductDetails = new Set()
            $.each($(html).find('.search_product_item'), function () {
              if (
                checkFitment(
                  stringToObject($(this).data('str').slice(0, -1)),
                  data
                )
              ) {
                const productDetails = $(this).find('.card-title span').text()
                if (!uniqueProductDetails.has(productDetails)) {
                  customHtml +=
                    '<div class="search_product-tile" role="option">' +
                    '<div class="search_product-tile__inner">' +
                    ($(this).find('img').data('srcset')
                      ? '<img src="' +
                        $(this).find('img').data('srcset') +
                        '" width="150" height="100">'
                      : `<div style="width: 150px; height: 100px;">{{ 'image' | placeholder_svg_tag: 'placeholder-svg' }}</div>`) +
                    '<div class="search_product-tile__details">' +
                    '<div class="product-tile__name">' +
                    $(this).find('.card-title span').text() +
                    '</div>' +
                    '<div class="product-tile__details-upper" data-pid="' +
                    $(this).find('.product-item').data('product-id') +
                    '"></div>' +
                    '<div class="product-tile_handle">' +
                    $(this).find('.product-item').data('json-product').handle +
                    '</div>' +
                    '<div class="product-tile_price">' +
                    $(this).find('.price-item--sale').text() +
                    '</div>' +
                    '<div class="product-tile__actions">' +
                    '<button type="button" class="button button--txt tag-action">' +
                    (isSelectedProducts($(this).find('.card-title span').text())
                      ? '<i class="fas fa-times"></i> Remove'
                      : '<i class="fas fa-plus"></i> Select') +
                    '</button>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>'
                  uniqueProductDetails.add(productDetails)
                }
              }
            })
            $('#product-search-results').html(customHtml)
            $.unblockUI()
          }
        )
      }
    }
  })

  $(document).on('click', '.product-tile__actions button', function () {
    const title = $(this).parent().parent()[0].children[0].innerText
    const handle = $(this).parent().parent()[0].children[2].innerText

    if ($(this).text().includes('Select')) {
      $(this).html('<i class="fas fa-times"></i> Remove')
      $('#selected_active-products').append(
        '<li data-handle="' +
          handle +
          '">' +
          title +
          '<button class="remove-tag tag-action is-active" type="button"><i class="fas fa-times"></i></button></li>'
      )
      $('#no-products-msg').hide()
    } else {
      $(this).html('<i class="fas fa-plus"></i> Select')
      $('#selected_active-products li').each(function () {
        if ($(this).text().includes(title)) {
          $(this).remove()
        }
      })
      if ($('#selected_active-products li').length == 0) {
        $('#no-products-msg').show()
      }
    }
  })

  $(document).on('click', '#selected_active-products li button', function () {
    const title = $(this).parent().text()
    const object = $(this).parent()
    $('.search_product-tile__inner .product-tile__name').each(function () {
      if ($(this).text().trim() === title.trim()) {
        $(this)
          .parent()
          .find('.product-tile__actions button')
          .html('<i class="fas fa-plus"></i> Select')
        object.remove()
      }
    })

    if ($('#selected_active-products li').length == 0) {
      $('#no-products-msg').show()
    }
  })

  $('#additional_accessories').on('input', function () {
    data['comments'] = $(this).val()
  })

  $('#dragdrop').on('dragover dragenter', function (evt) {
    evt.preventDefault()
  })

  $('#dragdrop').on('drop', function (evt) {
    const fileInput = document.getElementById('imagedrop')
    $('#dragdrop').hide()
    $('#fileselect').show()
    $('#imagedrop-error').hide()
    const dT = new DataTransfer()
    dT.items.add(evt.originalEvent.dataTransfer.files[0])
    fileInput.files = dT.files
    const reader = new FileReader()
    reader.readAsDataURL(evt.originalEvent.dataTransfer.files[0])
    reader.onload = function (e) {
      $('#upload-file-wrapper-0 .uploader__preview').html(
        '<img src="' + e.target.result + '">'
      )
      $('#upload-file-wrapper-0 .uploader__preview').addClass(
        'without-before-element'
      )
      $('#upload-file-wrapper-0 .action-select').hide()
      $('#upload-file-wrapper-0 .action-remove').show()
      submittedFiles[0] = $('#imagedrop')[0].files
    }
    evt.preventDefault()
  })

  $('.uploader__file-wrapper').on('dragover dragenter', function (evt) {
    evt.preventDefault()
  })

  $('.uploader__file-wrapper').on('drop', function (evt) {
    const id = $(this).find('input').attr('id')
    const fileInput = document.getElementById(id)
    const dT = new DataTransfer()
    dT.items.add(evt.originalEvent.dataTransfer.files[0])
    fileInput.files = dT.files
    const reader = new FileReader()
    reader.readAsDataURL(evt.originalEvent.dataTransfer.files[0])
    reader.onload = function (e) {
      $(
        '#upload-file-wrapper-' + id.split('_')[1] + ' .uploader__preview'
      ).html('<img src="' + e.target.result + '">')
      $(
        '#upload-file-wrapper-' + id.split('_')[1] + ' .uploader__preview'
      ).addClass('without-before-element')
      $('#upload-file-wrapper-' + id.split('_')[1] + ' .action-select').hide()
      $('#upload-file-wrapper-' + id.split('_')[1] + ' .action-remove').show()
      submittedFiles[id.split('_')[1]] = $('#' + id)[0].files
    }
    evt.preventDefault()
  })

  $(':file').on('change', function () {
    const file = this.files[0]
    const id = $(this).attr('id')
    if (validateImage(file)) {
      $('#dragdrop').hide()
      $('#fileselect').show()
      $('#imagedrop-error').hide()
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        if (id == 'imagedrop') {
          $('#upload-file-wrapper-0 .uploader__preview').html(
            '<img src="' + e.target.result + '">'
          )
          $('#upload-file-wrapper-0 .uploader__preview').addClass(
            'without-before-element'
          )
          $('#upload-file-wrapper-0 .action-select').hide()
          $('#upload-file-wrapper-0 .action-remove').show()
          submittedFiles[0] = $('#imagedrop')[0].files
        } else {
          $(
            '#upload-file-wrapper-' + id.split('_')[1] + ' .uploader__preview'
          ).html('<img src="' + e.target.result + '">')
          $(
            '#upload-file-wrapper-' + id.split('_')[1] + ' .uploader__preview'
          ).addClass('without-before-element')
          $(
            '#upload-file-wrapper-' + id.split('_')[1] + ' .action-select'
          ).hide()
          $(
            '#upload-file-wrapper-' + id.split('_')[1] + ' .action-remove'
          ).show()
          submittedFiles[id.split('_')[1]] = $('#' + id)[0].files
        }
      }
    }
  })

  const validateImage = (file) => {
    const maxSizeInBytes = 5 * 1024 * 1024
    if (
      file.type.startsWith('image/') &&
      file.size > 0 &&
      file.size <= maxSizeInBytes
    ) {
      return true
    }

    return false
  }

  $('.action-remove').on('click', function () {
    id = $(this).parent().parent().attr('id')
    $('#' + id + ' .uploader__preview img').remove()
    $('#' + id + ' .uploader__preview').html(
      '<i class="fa fa-camera camera_icon"></i>'
    )
    $('#' + id + ' .uploader__preview').removeClass('without-before-element')
    $('#' + id + ' .action-select').show()
    $('#' + id + ' .action-remove').hide()
    $('#' + id + ' input').val('')
    submittedFiles[id.split('-')[3]] = null
    if ($('.uploader__preview img').length == 0) {
      $('#dragdrop').show()
      $('#fileselect').hide()
      $('#imagedrop').val('')
      $('#imagedrop-error').show()
    }
  })
})
